import { render } from "./StudentEntryForm.vue?vue&type=template&id=7b8c5192"
import script from "./StudentEntryForm.vue?vue&type=script&lang=js"
export * from "./StudentEntryForm.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src439103385/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__